import { render, staticRenderFns } from "./AnnouncementDropdown.vue?vue&type=template&id=6cad941f&"
import script from "./AnnouncementDropdown.vue?vue&type=script&lang=js&"
export * from "./AnnouncementDropdown.vue?vue&type=script&lang=js&"
import style0 from "./AnnouncementDropdown.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports